import clsx from 'clsx';
import { forwardRef } from 'react';

export const TableRow = forwardRef<HTMLTableRowElement, React.HTMLAttributes<HTMLTableRowElement>>(
    ({ className, ...props }, ref) => (
        <tr ref={ref} className={clsx('flex', className)} {...props} />
    )
);
